export class TooltipText {
  public static readonly titleQueueSettings: string = `Queue settings`;

  public static readonly indicator: string = `* indicates required setting`;

  public static readonly titleSLA: string = `SLA`;
  public static readonly subtitleCaseOpenSLA: string = `Case Flagged`;
  public static readonly subtitleNearSLAWarningFactor: string = `Case Warning`;
  public static readonly subtitleTimeLimitForCaseSets: string = `Case Time Limit`;
  public static readonly subtitleCaseCollapsingWindow: string = `Case Collapsing Window`;

  public static readonly titleCases: string = `Cases`;
  public static readonly subtitleCasesPerSet: string = `Cases per set*`;
  public static readonly subtitleShowCaseDetails: string = `Show case details`;
  public static readonly subtitleAllowEmptyCommentsField: string = `Allow Empty Comments Field`;
  public static readonly subtitleNotAssignable: string = `Don't allow cases to be reviewed`;
  public static readonly subtitleSorting: string = `Sorting`;

  public static readonly titleContentPreviews: string = `Content previews`;
  public static readonly subtitleBlurThumbnailsByDefault: string = `Blur thumbnails by default`;
  public static readonly subtitleDesaturateThumbnailsByDefault: string = `Desaturate thumbnails by default`;
  public static readonly subtitleFlipThumbnailsByDefault: string = `Flip thumbnails by default`;

  public static readonly configCaseOpenLifetimeInSeconds: string = `How long a case can remain in an open state before it is flagged for being out of
  SLA. Minimum setting is 1 minute.`;

  public static readonly configCaseOpenLifetimeWarningFactor: string = `Percentage of how close to the Case Open SLA an open case can get before it
  gets counted as being Near SLA. Minimum setting is 1%.`;

  public static readonly configCaseAssignedLifetimeInSeconds: string = `How long a set of open cases is assigned to a moderator. Once this time expires,
  the cases return to the queue for moderation. Minimum setting is 1 minute.`;

  public static readonly configCollapsingWindowInSeconds: string = `How long after a case has been closed does feedback for the same subject resolve to the same case.
  After the window, feedback for the same subject will result in a new case being opened. Minimum setting is 1 minute.`;

  public static readonly configModeratorFeedbackCommentOptional: string = `Allows moderators to submit feedback without adding a comment. When
  unchecked, they must enter a comment before submitting feedback.`;

  public static readonly configNotAssignable: string = `Don't allow moderators to see this queue. Admins will still see the queue, but not be able to review.`;

  public static readonly configTitleFormat: string = '{tenant.DisplayName} > {title.DisplayName} > {subjectType}';

  public static readonly configCaseOpenLifetimeMaxInSeconds: string = `Maximum time that a case can remain in an open state before it is automatically closed`;

  public static readonly configDefaultCaseComparerAlgorithm: string = `This changes how cases in the moderation queue are prioritized. Highest priority
  cases are automatically assigned to the next available moderator`;

  public static readonly configDefaultMaxAssignedCaseCount: string = `The maximum number of cases within a set that a moderator can be assigned at
  any given time. Maximum setting is 30 cases.`;

  public static readonly validationTimeMessage: string = `Must be 1 minute or more`;

  public static readonly validationPercentageMessage: string = `Must be 1 % or more`;

  public static readonly validationCaseMessage: string = `Must be 1 case or more`;

  public static readonly addNewUserTitle: string = `Add new user`;

  public static readonly userListTitle: string = `People and roles`;

  public static readonly userAddedSuccessfully: string = `User added`;

  public static readonly removeUserPopUpTitle: string = `Remove user?`;

  public static readonly removeUserPopUpSubText: string = `Are you sure you want to remove this user? This action cannot be undone.`;

  public static readonly validationInvalidUserIdFormat: string = `Invalid user ID format`;

  public static readonly validationUserExist: string = `User is already in queue`;

  public static readonly titleQueueAccess: string = `Queue access`;

  public static readonly unsupportedTypeText: string = `Unsupported Type: `;

  public static readonly unsupportedContentTypeTitle: string = `Unsupported Content Type in queue configuration.`;
  public static readonly unsupportedContentTypeMessage: string = `An update to the Queue Configuration to a supported Content Type will be required to use this queue.`;

  public static readonly jsonContentTypeOutputValidationMessage: string = `Error: wrong output`;
  public static readonly headerTypeValidationMessage: string = `Wrong value of header type value`;
  public static readonly headerValueTypeValidationMessage: string = `Wrong value of headerValue type header or value`;
  public static readonly sectionHeaderTypeValidationMessage: string = `Wrong value of sectionHeader type`;
  public static readonly iframeTypeValidationMessage: string = `Wrong value of iframe type value`;
  public static readonly imageBytesTypeValidationMessage: string = `Wrong value of image bytes type value`;
  public static readonly imageUrlTypeValidationMessage: string = `Wrong value of image url type value`;
  public static readonly imageCarouselTypeValidationMessage: string = `Wrong value of imageCarousel type value`;
  public static readonly tableTypeValidationMessage: string = `Wrong value of table type value or focusText`;
  public static readonly tableTypeCellValidationMessage: string = `Error: wrong value`;
  public static readonly textTypeValidationMessage: string = `Wrong value of text type value`;
  public static readonly urlTypeValidationMessage: string = `Wrong value of url type value`;
}
